import { render, staticRenderFns } from "./DeliveryPointsFileForm.vue?vue&type=template&id=8130c078&scoped=true&"
import script from "./DeliveryPointsFileForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryPointsFileForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPointsFileForm.vue?vue&type=style&index=0&id=8130c078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8130c078",
  null
  
)

export default component.exports